import React, { PropsWithChildren } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { default as MuiSnackbar } from '@mui/material/Snackbar';

import { errorRed, white87, printHidden, sizeDesktop, turquoise, sizeMobile } from '~/styles';

interface MuiSnackbarProps extends React.ComponentProps<typeof MuiSnackbar> {
  alignRightMobile?: boolean;
}

const BaseMuiSnackbar: React.FC<MuiSnackbarProps> = ({ ...props }) => (
  <MuiSnackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} {...props} />
);

export const Snackbar_: React.FC<PropsWithChildren<MuiSnackbarProps>> = styled(BaseMuiSnackbar, {
  shouldForwardProp: prop => !['alignRightMobile'].includes(prop),
})<MuiSnackbarProps>`
  margin-left: 80px;
  ${sizeDesktop(css`
    margin-left: 0;
  `)}
  ${({ alignRightMobile }) =>
    alignRightMobile &&
    css`
      ${sizeMobile(css`
        left: auto;
        right: 25px;
      `)}
    `}
  
  ${printHidden};
` as React.FC<PropsWithChildren<MuiSnackbarProps & React.ComponentProps<typeof MuiSnackbar>>>;

export const SnackbarHeader = styled.div<{ variant?: string }>`
  margin-bottom: 10px;
  font-weight: 600;
  color: ${turquoise};
  ${({ variant }) =>
    variant &&
    ((variant === 'red' &&
      css`
        color: ${errorRed};
      `) ||
      (variant === 'white' &&
        css`
          color: ${white87};
          font-weight: 400;
          letter-spacing: 0.4px;
        `))}
`;
